import { Outlet, Navigate, useLocation } from "react-router-dom";
import WarehouseNavBar, {
  WAREHOUSE_NAV_ITEMS,
  WAREHOUSE_HELPER_ALLOWED_URLS,
} from "../Navbar/WarehouseNavBar";

const warehousePermissions = [
  { url: "/warehouse-dashboard", name: "" },
  { url: "/warehouse-orders", name: "shipper.access.order.view" },
  { url: "/warehouse-clients", name: "" },
  { url: "/warehouse-products", name: "shipper.access.product.view" },
  { url: "/warehouse-payments", name: "shipper.access.payment.view" },
  { url: "/warehouse-ship", name: "" },
  { url: "/storage-locations", name: "" },
  { url: "/warehouse-AddProduct", name: "shipper.access.product.create.packages" },
  { url: "/warehouse-stock-received-form", name: "" },
  { url: "/warehouse/settings/manage-helper-users", ownerOnly: true },
  { url: "/warehouse/settings/manage-roles", ownerOnly: true },
  { url: "/warehouse/settings/manage-permissions", ownerOnly: true },
];

const normalizePath = (path) => (path || "").replace(/\/+$/, "").toLowerCase() || "/";

const navUrlSet = new Set(WAREHOUSE_NAV_ITEMS.map((i) => normalizePath(i.url)));
const helperAllowedSet = new Set(
  WAREHOUSE_HELPER_ALLOWED_URLS.map((u) => normalizePath(u))
);

const WarehouseRoutes = (props) => {
  const role = localStorage.getItem("Role");
  const location = useLocation();

  if (role === "warehouseUser") {
    const isOwner = !props?.parentId;
    const matched = warehousePermissions.find(
      (p) => normalizePath(p.url) === normalizePath(location.pathname)
    );

    const path = normalizePath(location.pathname);

    let allowed;
    if (matched?.ownerOnly) {
      allowed = isOwner;
    } else if (isOwner) {
      allowed = true;
    } else if (navUrlSet.has(path) && !helperAllowedSet.has(path)) {
      allowed = false;
    } else if (!matched?.name) {
      allowed = true;
    } else {
      if (!Array.isArray(props?.mergedPermissions)) return null;
      allowed = props.mergedPermissions.includes(matched.name);
    }

    if (allowed) {
      return (
        <>
          <WarehouseNavBar />
          <Outlet />
        </>
      );
    }
    return <Navigate to="/unauthorized" />;
  } else if (
    role === "Shipper" ||
    role === "ShipperUser" ||
    role === "oneTimeShipper"
  ) {
    return <Navigate to="/" />;
  } else if (role === "Carrier") {
    return <Navigate to="/create-zone" />;
  } else if (role === "Admin") {
    return <Navigate to="/Users" />;
  } else {
    return <Navigate to="/Login" />;
  }
};

export default WarehouseRoutes;
